// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S2Nm","largestCol":"styles_largestCol__3zV6B","smallestCol":"styles_smallestCol__111nS"};